import React from 'react';
import * as yup from 'yup';
import { Formik } from 'formik';
import { useHistory } from 'react-router-dom';
import { StatusCodes } from 'http-status-codes';

import WhitePad from '../../../../components/common/WhitePad/WhitePad';
import BrandsApi from '../../../../services/api/BrandsApi';
import { UPLOAD_MAX_SIZE_IMAGE, SUPPORTED_IMAGE_FORMATS } from '../../../../utils/constants';
import FormRow from '../../../../components/common/forms/Row/FormRow';
import TextInputComponent from '../../../../components/common/forms/TextInput/TextInputComponent';
import FileInputComponent from '../../../../components/common/forms/FileInput/FileInputComponent';
import PrimaryButton from '../../../../components/common/forms/Button/PrimaryButton';
import TitleComponent from '../../../../components/common/forms/Title/TitleComponent';
import FormWrapper from '~/src/components/common/forms/FormWrapper/FormWrapper';

const validationSchema = yup.object().shape({
  name: yup.string().label('Name').min(2, 'Name should be at least 2 symbols').required('Name is required'),
  logo: yup
    .mixed()
    .test('fileSize', 'Max upload file 3MB', (value) => {
      if (typeof value === 'undefined' || value.length <= 0) {
        return true;
      }
      return value[0].size <= UPLOAD_MAX_SIZE_IMAGE;
    })
    .test('fileType', 'Please use filetype JPG, JPEG, or PNG', (value) => {
      if (typeof value === 'undefined' || value.length <= 0) {
        return true;
      }

      return SUPPORTED_IMAGE_FORMATS.includes(value[0].type);
    }),
});

export default function BrandCreate(): JSX.Element {
  const history = useHistory();

  const saveItem = async (values, setSubmitting) => {
    setSubmitting(true);
    const res = await BrandsApi.create(values);
    if (res.status === StatusCodes.OK) {
      history.push('/brands');
    } else {
      setSubmitting(false);
    }
  };

  const onHandleChange = (event, setFieldValue) => {
    const { files } = event.target;
    setFieldValue('logo', files);
  };

  return (
    <WhitePad>
      <TitleComponent onLeftHandler={history.goBack} titleLeft="Back" title="Create Brand" />
      <FormWrapper>
        <Formik
          initialValues={{
            name: '',
            logo: [],
          }}
          validationSchema={validationSchema}
          onSubmit={(values, { setSubmitting }) => saveItem(values, setSubmitting)}
        >
          {({ values, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue }) => (
            <form onSubmit={handleSubmit} autoComplete="off">
              <FormRow>
                <TextInputComponent
                  label="Name"
                  name="name"
                  value={values.name}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  cols={12}
                />
                <FileInputComponent
                  name="logo"
                  value={values.logo}
                  onBlur={handleBlur}
                  onChange={onHandleChange}
                  setFieldValue={setFieldValue}
                  cols={12}
                />
              </FormRow>
              <PrimaryButton isSubmitting={isSubmitting} type="submit" title="Save" />
            </form>
          )}
        </Formik>
      </FormWrapper>
    </WhitePad>
  );
}
